var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"Hero"},[_c('div',{staticClass:"Hero__inner"},[_c('div',{staticClass:"Hero__content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }